/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const createContactBusinessRelationshipRequestDtoTypeEnum = {
  AGENT: "AGENT",
  BRAND: "BRAND",
  MANUFACTURER: "MANUFACTURER",
  OTHER: "OTHER",
  RAW_MATERIAL_SUPPLIER: "RAW_MATERIAL_SUPPLIER",
  SUPPLIER: "SUPPLIER",
  TRADER: "TRADER",
} as const

export type CreateContactBusinessRelationshipRequestDtoTypeEnumKey =
  (typeof createContactBusinessRelationshipRequestDtoTypeEnum)[keyof typeof createContactBusinessRelationshipRequestDtoTypeEnum]

export type CreateContactBusinessRelationshipRequestDto = {
  /**
   * @description Supplier is active
   * @type boolean
   */
  isActive: boolean
  /**
   * @description Supplier code
   * @type string
   */
  supplierCode: string | null
  /**
   * @description Business relationship type
   * @type string
   */
  type: CreateContactBusinessRelationshipRequestDtoTypeEnumKey | null
  /**
   * @description Tag names
   * @type array | undefined
   */
  tagNames?: string[]
}
